import {useState} from "react";
import {api,errMsg} from "@/lib/api";

/** Manual, educational risk sizing. Never submits orders to a broker. */
export default function RiskCalculator(){
 const [values,setValues]=useState({capital:"1000",risk_percent:"1",entry_price:"100",stop_price:"95",target_price:"110",side:"long"});
 const [result,setResult]=useState(null),[error,setError]=useState(""),[busy,setBusy]=useState(false);
 const change=e=>{setValues(v=>({...v,[e.target.name]:e.target.value}));setResult(null);setError("")};
 const submit=async e=>{
  e.preventDefault();setBusy(true);setError("");setResult(null);
  try{
   const payload={...values,target_price:values.target_price===""?null:values.target_price};
   const {data}=await api.post("/personal/finance/risk-estimate",payload);
   setResult(data);
  }catch(err){setError(errMsg(err))}
  finally{setBusy(false)}
 };
 return <section className="operations-card" aria-label="Calculadora de riesgo">
  <h2>Calculadora de riesgo</h2>
  <p>Estimación educativa. No conecta un bróker ni ejecuta operaciones.</p>
  <form onSubmit={submit}>
   <label>Capital disponible<input name="capital" type="number" min="0" max="100000000" step=".01" required value={values.capital} onChange={change}/></label>
   <label>Riesgo por operación (%)<input name="risk_percent" type="number" min=".01" max="100" step=".01" required value={values.risk_percent} onChange={change}/></label>
   <label>Dirección<select name="side" value={values.side} onChange={change}><option value="long">Compra (long)</option><option value="short">Venta (short)</option></select></label>
   <label>Precio de entrada<input name="entry_price" type="number" min=".00000001" step="any" required value={values.entry_price} onChange={change}/></label>
   <label>Stop-loss<input name="stop_price" type="number" min=".00000001" step="any" required value={values.stop_price} onChange={change}/></label>
   <label>Objetivo (opcional)<input name="target_price" type="number" min=".00000001" step="any" value={values.target_price} onChange={change}/></label>
   <button disabled={busy} type="submit">{busy?"Calculando…":"Calcular riesgo"}</button>
  </form>
  {error&&<p role="alert" className="operations-alert">{error}</p>}
  {result&&<div role="status"><p>Pérdida máxima teórica: <strong>{result.max_loss}</strong></p><p>Unidades estimadas: <strong>{result.quantity}</strong></p><p>Riesgo por unidad: {result.price_risk_per_unit}</p>{result.estimated_reward!==null&&<p>Beneficio teórico: {result.estimated_reward} · Relación beneficio/riesgo: {result.reward_risk_ratio}</p>}<p className="operations-note">{result.note}</p></div>}
 </section>;
}
